module.exports = "<div class=\"banner {{ bannerClass }} animated\" ng-show=\"showBanner\">\n  <div class=\"banner-content center\" ng-transclude>\n  </div>\n  <button class=\"banner-close-btn pull-right\" ng-click=\"showBanner = false\">\n    <i class=\"ion-close\"></i>\n  </button>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/directives/banner/template.html
// module id = 1215
// module chunks = 0